/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { generateSimplestList, SimpleAttributeList } from '@touchplan/common';
import { DefaultSplitDataRenderType, SplitData } from '@touchplan/common';

export interface IProjectFile {
	gcsBucket: string;
	gcsBlob: string;
}

export class ProjectFile extends SplitData<IProjectFile, DefaultSplitDataRenderType> {
	protected useInPlace = true;
	protected attributeList: SimpleAttributeList = Object.assign(
		generateSimplestList(['gcsBucket', 'gcsBlob']),
		{}
	);

	constructor(id: string) {
		super(id, DefaultSplitDataRenderType.database);
	}
}
